import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55106060"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-us-content-block-wrap" }
const _hoisted_2 = { class: "about-us-content-block" }
const _hoisted_3 = { class: "about-us-content-block-text" }
const _hoisted_4 = { class: "about-us-content-block-image" }
const _hoisted_5 = { class: "about-us-content-block-text" }
const _hoisted_6 = { class: "about-us-content-block-text" }
const _hoisted_7 = { class: "about-us-content-block-text" }

import {handshake, useLocalizationStore} from "@/shared";
import {WrapTitle} from "@/entities";


export default /*#__PURE__*/_defineComponent({
  __name: 'about-us-content-block',
  setup(__props) {

const {translate} = useLocalizationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString(_unref(translate)("about_us_content_first_text")), 1),
        _createElementVNode("div", null, _toDisplayString(_unref(translate)("about_us_content_second_text")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          style: _normalizeStyle({backgroundImage:'url('+_unref(handshake)+')'}),
          class: "about-us-image"
        }, null, 4)
      ]),
      _createVNode(_unref(WrapTitle), {
        text: _unref(translate)('about_us_content_second_title'),
        class: "about-us-content-block-title",
        size: "regular",
        weight: "700"
      }, null, 8, ["text"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, _toDisplayString(_unref(translate)("about_us_content_third_text")), 1),
        _createElementVNode("div", null, _toDisplayString(_unref(translate)("about_us_content_fourth_text")), 1)
      ]),
      _createVNode(_unref(WrapTitle), {
        text: _unref(translate)('about_us_content_third_title'),
        class: "about-us-content-block-title small",
        size: "regular",
        weight: "700"
      }, null, 8, ["text"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, _toDisplayString(_unref(translate)("about_us_content_fifth_text")), 1),
        _createElementVNode("div", null, _toDisplayString(_unref(translate)("about_us_content_sixth_text")), 1)
      ]),
      _createVNode(_unref(WrapTitle), {
        text: _unref(translate)('about_us_content_fourth_title'),
        class: "about-us-content-block-title small",
        size: "regular",
        weight: "700"
      }, null, 8, ["text"]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, _toDisplayString(_unref(translate)("about_us_content_seventh_text")), 1),
        _createElementVNode("div", null, _toDisplayString(_unref(translate)("about_us_content_eighth_text")), 1)
      ])
    ])
  ]))
}
}

})